import React, { useState, useEffect } from 'react';
import ghostImage from '../assets/images/albumimages/ghost.jpg';
import rwcImage from '../assets/images/albumimages/rwc.jpg';
import babyImage from '../assets/images/albumimages/baby.jpg';
import thriveImage from '../assets/images/albumimages/thrive.jpg';
import itchytastyImage from '../assets/images/albumimages/itchytasty.jpg';
import oceanImage from '../assets/images/albumimages/ocean.jpg';
import busyImage from '../assets/images/albumimages/busy.jpg';
import eighteenImage from '../assets/images/albumimages/18.jpg';
import musicJSON from '../data/music.json';

const imageMap = {
    "ghost.png": ghostImage,
    "rwc.png": rwcImage,
    "baby.png": babyImage,
    "thrive.png": thriveImage,
    "itchytasty.png": itchytastyImage,
    "ocean.jpg": oceanImage,
    "busy.jpg": busyImage,
    "18.jpg": eighteenImage
};

const RandomMusic = () => {
    const [currentImage, setCurrentImage] = useState(null);
    const [isCycling, setIsCycling] = useState(false);
    const [chosenAlbum, setChosenAlbum] = useState(null);

    useEffect(() => {
        let cycleInterval;
        if (isCycling) {
            cycleInterval = setInterval(() => {
                const randomIndex = Math.floor(Math.random() * musicJSON.length);
                setCurrentImage(imageMap[musicJSON[randomIndex].images[0].path]);
            }, 100); 
        } else if (chosenAlbum) {
            const timer = setTimeout(() => {
                window.open(chosenAlbum.website, '_blank');
            }, 3000); 
            return () => clearTimeout(timer);
        }
        return () => clearInterval(cycleInterval);
    }, [isCycling, chosenAlbum]);

    const handleClick = () => {
        setIsCycling(true);
        setTimeout(() => {
            setIsCycling(false);
            const randomIndex = Math.floor(Math.random() * musicJSON.length);
            setChosenAlbum(musicJSON[randomIndex]);
            setCurrentImage(imageMap[musicJSON[randomIndex].images[0].path]);
        }, 3000);
    };

    return (
        <div className="flex flex-col items-center">
            <button onClick={handleClick} className="bg-gray-600 px-4 py-2 rounded-md mb-4">
                Album lucky dip
            </button>
            {currentImage && (
                <img className="object-cover h-64 w-64 rounded-lg" src={currentImage} alt="Random Album" />
            )}
        </div>
    );
};

export default RandomMusic;